module.exports = __webpack_public_path__ + "img/combinethreecoins.9918327c.svg";